<div
  class="progress"
  [style.width]="percentage + '%'"
  [style.border-radius]="percentage === 100 ? '6px' : '6px 0 0 6px'"
  [class.disabled]="disabled"
></div>
